<style lang="less" scoped></style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">操作记录</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">记录查询时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                v-model="lastSearchTime"
                style="width: 100%"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd 00:00:00"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="lastHandleDateChange"
              ></el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button class="common-bg-button" @click="handleExportFun()">
            导 出
          </button>
        </template>
      </ZD-list-querys>
      <div class="page-action-btns flex">
        <!-- <button class="common-bg-button" @click="listAddFun()">新 增</button>
                <button class="common-bg-button" @click="listEditFun()">编 辑</button> -->
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels
            }
          "
        ></ZD-table>
       
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
import utils from '../../../utils/utils'
import config from '../../../config/config'
import axios from 'axios'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      lastSearchTime:[],
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {},  //页码 与搜索内容
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
      searchTime: [],  //选择日期
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  methods: {
    lastHandleDateChange(val) {
      if (val) {
        this.queryInfo.createTimeFrom = val[0];
        this.queryInfo.createTimeTo = val[1];
      } else {
        delete this.queryInfo.createTimeFrom;
        delete this.queryInfo.createTimeTo;
      }
    },

    init() {
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this

      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize
      
      _.$H.get(_, _.$A.operationRecords.page, _.queryInfo).then(res => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
      })
      
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.fromTime = val[0]
        this.queryInfo.toTime = val[1]
      } else {
        delete this.queryInfo.fromTime
        delete this.queryInfo.toTime
      }
    },
    handleExportFun() {
      let _ = this;
        _.$U.showLoading(_);
        
        _.$H
          .post(_, _.$A.operationRecords.export, _.queryInfo)
          .then((res) => {
            _.$U.hideLoading(_);
            let filePath = res.data.data.data;
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 后台本地地址
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
            let downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
            window.open(downUrl, "_blank");
          });
    },
  },
  mounted() {
    this.init()
  },
}
</script>
